import React from "react";
import { Link } from "react-router-dom";

export default function BreadCrumb({ data }) {
  return (
    <ul className="dynamic-breadcrumb">
      <li>
        <Link to="/">Home</Link>
      </li>

      {Array.isArray(data) &&
        data.filter(item => item?.name?.trim() !== "")
          .map((item, ind, arr) => (
            <li key={ind} aria-current={ind === arr.length - 1 ? "page" : undefined} >
              {ind === arr.length - 1 || !item.slug ? (item.name
              ) : (
                <Link to={item.slug}>{item.name}</Link>
              )}
            </li>
          ))}
    </ul>


  );
}
